import { Component, Input } from "@angular/core";
import { User } from "../../../../models";

@Component({
  selector: "del-account-button",
  templateUrl: "./del-account-button.component.html",
  styleUrls: [
    "./del-account-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelAccountButtonComponent {
  @Input() currentUser: User;
  constructor() {}
  ngOnInit() {}
}
